import { createNode } from "@front/utils";
import { createComponent } from "@front/utils/alpine";

export default createComponent(({ $persist, $defaults }) => ({
    videoUrl: '',
    placeholderClasses: [],

    async setup () {
        if (!this.videoUrl) {
            return;
        }

        const endpoint = new URL('https://vimeo.com/api/oembed.json');
        Object.entries({
            url: this.videoUrl,
            background: true,
        }).forEach(([k, v]) => endpoint.searchParams.append(k, v));

        const response = await fetch(endpoint.toString());
        const data = await response.json();

        const iframe = createNode<HTMLIFrameElement>(data.html);
        iframe.classList.add(...this.placeholderClasses);

        this.$el.replaceChild(iframe, this.$refs.placeholder);
    },

    init () {
        this.videoUrl = this.$el.dataset.videoUrl;
        this.placeholderClasses = this.$refs.placeholder.classList;
    },
}));
